import React, { useState } from "react";
import "./RRHHAdmin.css";
import ListadoPostulanteContratado from "./ListadoPostulanteContratado";
import { useSearchParams } from "react-router-dom";
import Permiso from "../../router/Permiso";
import ListadoBaja from "./ListadoBaja";

const RRHHAdmin = ({ token }) => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'postulantes';
  const [tab, setTab] = useState(initialTab);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };


  const renderTab = () => {
    switch (tab) {
      case "postulantes":
        return <ListadoPostulanteContratado token={token} onRefresh={handleRefresh} />;
        case "bajas":
        return <ListadoBaja token={token} onRefresh={handleRefresh} />;
      default:
        return null;
    }
  };

  return (
    <div className="rrhh-admin-outer">
      <div className="rrhh-admin-header">
        <div className="rrhh-admin-header-row">
          <div>
            <div className="usuarios-admin-title">Recursos Humanos</div>
            <div className="rrhh-admin-subtitle">
              Gestión profesional de Recursos Humanos
            </div>
          </div>
        </div>
        <div className="usuarios-admin-tabs">
          <Permiso permiso="rrhh_list_postulante">
            <button
              className={tab === "postulantes" ? "active" : ""}
              onClick={() => setTab("postulantes")}
            >
              Listado de Postulantes
            </button>
          </Permiso>
          <Permiso permiso="rrhh_list_solicitudes_baja">
            <button
              className={tab === "bajas" ? "active" : ""}
              onClick={() => setTab("bajas")}
            >
              Solicitudes de Bajas
            </button>
          </Permiso>
        </div>
      </div>
      <div className="rrhh-admin-tab-content">
        <div className="reclutamiento-admin-tab-content">{renderTab()}</div>
      </div>
    </div>
  );
};

export default RRHHAdmin;
